import { type CampoSemantico } from '@framework/api-client/api/inquiries-compile/schemas/campoSemantico.ts';
import { type IEngineRawSemanticField } from './IEngineRawSemanticField.ts';

export type SemanticFieldsRecord = Record<string, any>;

// In caso di validatore:
// CampoSemanticoDto (implementa IEngineRawSemanticField) -> parseRawSemanticFields -> SemanticFieldsRecord
// In caso di FE (da risposta BE):
// CampoSemantico -> backendToRawSemanticFields -> parseRawSemanticFields -> SemanticFieldsRecord

/**
 * Effettua il parsing dei campi semantici provenienti dal **Backend**
 * (chiamate API del Frontend) nel formato intermedio utilizzato dal
 * **Validatore** (input del motore di validazione).
 */
export function backendToRawSemanticFields(
  semanticFields: CampoSemantico[] | null | undefined,
): IEngineRawSemanticField[] {
  return (
    semanticFields?.map(sf => ({
      id: sf.tagSemantico?.id ?? '<unknownId>',
      nome: sf.tagSemantico?.nome ?? '<unknown>',
      valore: sf.valore,
    })) ?? []
  );
}

/**
 * Funzione che converte i campi semantici del **Validatore** in un oggetto
 * chiave-valore
 */
export function parseRawSemanticFields(
  semanticFields: IEngineRawSemanticField[] | null | undefined,
): SemanticFieldsRecord {
  return (
    semanticFields?.reduce((acc: Record<string, any>, sf) => {
      acc[sf.nome ?? '<unknown>'] = sf.valore;
      return acc;
    }, {}) ?? {}
  );
}
